import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero__pill">
        <span className="hero__pill-dot"></span>
        Built from 15,000+ real Porsche auction results
      </div>
      {/* 
      <h1 className="hero__title">
        <span className="hero__title-line">Your Online Auction Companion</span>
        <span className="hero__title-line">That Gives You <span className="hero__highlight">Auction Data</span></span>
        <span className="hero__title-line">While You Browse Listings</span>
      </h1>
      */}
      <h1 className="hero__title">
        <span className="hero__title-line">Stop leaving <em className="hero__highlight hero__italic">thousands</em></span>
        <span className="hero__title-line">on the table.</span>
      </h1>
      <p className="hero__subtitle">
        Bidder iQ gives serious Porsche buyers and sellers the real<br />
        auction data they need to make confident, accurate decisions.
      </p>
      <div className="hero__cta-row">
        <a href="/sign-up" className="hero__cta">Don't Overbid — Start Now</a>
        <a href="https://www.loom.com/share/65f2f6070c384921b5eef534644acd41" target="_blank" rel="noopener noreferrer" className="hero__cta hero__cta--secondary">See How It Works</a>
      </div>
      <p className="hero__trust">
        Trusted by <strong>hundreds</strong> of Porsche enthusiasts, collectors, and dealers.
      </p>
      <ul className="hero__benefits">
        <li><span className="hero__benefit-check">✓</span> Instant access</li>
        <li><span className="hero__benefit-check">✓</span> Cancel anytime</li>
        <li><span className="hero__benefit-check">✓</span> Real sold &amp; unsold data</li>
        <li><span className="hero__benefit-check">✓</span> Chrome Extension included</li>
      </ul>
    </section>
  );
}

export default Hero;
